<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/micf_banner1.png');">
          <div class="banner_item1_content">
            <p>微型消防站管理系统</p>
            <p class="txt1">
              在3分钟内赶到现场，快速处置或控制火灾蔓延，并组织人员疏散
            </p>
            <div class="item1_infoBox">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案背景</span>
          <span>全面推开将为科学高效监管提供新思路</span>
        </div>
        <div class="part1_section">
          <div>
            <span>微型消防站的重要性</span>
            <span></span>
            <span>公安部消防局立足火灾防控现实斗争需要，结合单位、社区消防工作特点，在全国组织开展了微型消防站建设。主要目的是一旦发生火灾，微型消防站力量能够在3分钟内赶到现场，快速处置或控制火灾蔓延，并组织人员疏散。微型消防站建设是公安部消防局党委结合现阶段消防工作实际作出的重要部署，对于稳定火灾形势、减少人员伤亡具有重要意义。但是，从抽查测试和实际使用情况来看，各地在微型消防站管理、培训、使用等方面，还是存在一些不足，尚未真正形成战斗力。</span>
          </div>
          <div>
            <img src="static/image/micf_part1_bg1.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">方案简介</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">移动消防勤务系统：具有防火巡查、信息采集、消防宣传、灭火救援四大职能，另外移动消防勤务系统还可以和独立式火灾探测报警云平台、公安视频平台对接，实现九小场所的火灾报警信息推送和视频联动核实火情，使特勤人员能够第一时间赶赴现场扑救。</span>
        </div>
        <div class="part2_item">
          <div class="part2_itemInfo" v-for="(item,index) in partList" :key="index+'partList'" @mouseover="addActive($event,index)" @mouseleave="removeActive($event,index)">
            <img :src="item.imgSrc" :class="item.imgSize" alt="">
            <span :class="item.txtColor">{{item.txt}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">解决方案</span>
          <span class="part1_header_txt2">全面推开将为科学高效监管提供新思路</span>
          <span class="part1_header_txt3">主要实现责任范围管理、安全生产管理、隐患综合治理、一张图预警和综合管理等功能。其中安全生产管理又包括目标管理、管理架构、专项工作落实、安全生产责任制、领导责任落实、安全检查、宣传培训、设备管理、安全生产投入、职业卫生健康等功能。隐患综合治理包括隐患台账、隐患随手拍、整改派单、现场整改、整改审核和闭环存档。</span>
        </div>
        <div class="part3_img">
          <img src="static/image/micf_part3_bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_content_btn">
          主要功能框架
        </div>
        <div class="part5_content_item">
          <div>

          </div>
        </div>
        <div class="part5_content_item1">
          <div></div>
          <div class="part5_content_border"></div>
          <div></div>
          <div class="part5_content_border"></div>
          <div></div>
        </div>
        <div class="part5_content_item2">
          <div :class="item.bgColor" v-for="(item,index) in resultList" :key="index+'resultList'" @mouseover="addActive1($event,index)" @mouseleave="removeActive1($event,index)">
            <div>
              <img :src="item.normalSrc" alt="">
            </div>
            <span :class="item.txt1Class">{{item.txt1}}</span>
            <span :class="item.txt2Class" v-for="(item1,index1) in item.txt2" :key="index1">{{item1}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">微型消防站信息化建设与管理</p>
        <div class="part6_content_img">
          <img src="static/image/micf_part6_bg1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">微型消防站培训演练线上管理</p>
        <div class="part6_content_img">
          <img src="static/image/micf_part6_bg2.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">微型消防站应急联动管理</p>
        <div class="part6_content_img">
          <img src="static/image/micf_part6_bg3.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">微型消防站培训演练线上管理</p>
        <div class="part6_content_img">
          <img src="static/image/micf_part6_bg4.png" alt="">
        </div>
      </div>
    </div>
    <div class="part6Box">
      <div class="part6_content">
        <p class="part6_content_txt">重要岗位值班在线监督抽检管理</p>
        <div class="part6_content_img">
          <img src="static/image/micf_part6_bg5.png" alt="">
        </div>
      </div>
    </div>
    <div class="part7Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">系统优势</span>
          <span class="part1_header_txt2">智能化、精细化、多功能于一体的消防体系</span>
        </div>
        <div class="part7_item">
          <div class="part7_item_box1">
            <img src="static/image/micf_part7_bg1.png" alt="">
            <p class="part7_item_txt">训练课时化</p>
            <p class="part7_item_txt1">系统通过课时化训练机制和现代化认证技术，对微型消防站的课时训练情况进行闭环管理。</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/micf_part7_bg2.png" alt="">
            <p class="part7_item_txt">管理精细化</p>
            <p class="part7_item_txt1">通过大数据一张图，对各类进行分析研判，做到管理精细化、系统化。</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/micf_part7_bg3.png" alt="">
            <p class="part7_item_txt">系统开放接口</p>
            <p class="part7_item_txt1">系统开放接口，可与支队已建大数据系统、单位责任检测系统进行打通，各系统之间可实时联动。</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/micf_part7_bg4.png" alt="">
            <p class="part7_item_txt">建站标准化</p>
            <p class="part7_item_txt1">通过消防“微”士系统，建立统一的建站标准体系，实现士标准化管理</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/micf_part7_bg5.png" alt="">
            <p class="part7_item_txt">战斗一体化</p>
            <p class="part7_item_txt1">通过“一张图”方式实现集成区域联防联勤、警情实时推送、力量自动调派、语音双向联络、图像远程传输等应用，形成防火巡查、灭火救援调度等一体化战斗体系</p>
          </div>
          <div class="part7_item_box1">
            <img src="static/image/micf_part7_bg6.png" alt="">
            <p class="part7_item_txt">手机监督抽查，奖惩曝光，有力管控各单位</p>
            <p class="part7_item_txt1">消防监督检查人员通过手机对微型消防站进行不定期监督抽查，并引入“奖惩机制”，将企业纳入诚信管理，将不合格单位进行全市通报，有力管控各单位的微型消防站运行情况。</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part8Box">
      <div class="part1_content">
        <div class="part1_header">
          <span class="part1_header_txt1">相关案例</span>
          <span class="part1_header_txt2">多站点、覆盖广，建立消防一体化体系</span>
          <span class="part1_header_txt3">建立微型消防站4201个，区域联防组织70个，安装简易喷淋289套，独立式感烟火灾探测报警器9431只。系统预计用户人数不低于16000人，同时在线人数不低于2000人。</span>
        </div>
        <div class="part2_item">
          <div class="part2_itemInfo" v-for="(item,index) in partList1" :key="index+'partList1'">
            <div class="part6_content_img">
              <img :src="item.imgSrc" alt="">
            </div>
            <p :class="item.txtColor">{{item.txt}}</p>
            <span :class="item.txtColor">{{item.txt1}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part9Box">
      <div class="part9_content">
        <div class="part9_item1">
          <img src="static/image/micf_part9_bg1.png" alt="">
        </div>
        <div class="part9_item2">
          <div class="part9_item2_txt1">
            南通消防“微”士系统
          </div>
          <span class="part9_item2_txt2"></span>
          <div class="part9_item2_txt3">
            为严控春节、两会火灾事故发生及今后迅速到场扑灭火灾，市消防支队按照“覆盖全面、整合力量、消防一体”的原则，把防灭火力量延伸到最基层、最末端，在村居和重点单位建立“防消一体化”微型消防站。为进一步推进微型消防站建设，提高微型消防站业务技能水平，充分发挥其消防安全巡查队、灭火救援先遣队南通消防支队拟对全市4000余家微型消防站进行长效化、规范化和智慧化管理和应急调度。
          </div>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>

</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "microFire",
    components: {HeaderCom, FooterCom, RegisterCom},
    data(){
      return{
        partList:[
          {
            imgSrc:"static/image/micf_part2_bg1.png",
            txt:"防火巡查",
            txtColor:"part2_itemInfo_txt1",
            imgSize:"",
          },
          {
            imgSrc:"static/image/micf_part2_bg2.png",
            txt:"信息采集",
            txtColor:"part2_itemInfo_txt1",
            imgSize:"",
          },
          {
            imgSrc:"static/image/micf_part2_bg3.png",
            txt:"消防宣传",
            txtColor:"part2_itemInfo_txt1",
            imgSize:"part2Img",
          },
          {
            imgSrc:"static/image/micf_part2_bg4.png",
            txt:"灭火救援",
            txtColor:"part2_itemInfo_txt1",
            imgSize:"",
          },

        ],
        partList1:[
          {
            imgSrc:"static/image/micf_part8_bg1.png",
            txt:"4021个",
            txt1:"微型消防站",
            txtColor:"part8_itemInfo_txt1",
          },
          {
            imgSrc:"static/image/micf_part8_bg2.png",
            txt:"70个",
            txt1:"区域联防组织",
            txtColor:"part8_itemInfo_txt1",
          },
          {
            imgSrc:"static/image/micf_part8_bg3.png",
            txt:"289套",
            txt1:"安装简易喷淋",
            txtColor:"part8_itemInfo_txt1",
          },
          {
            imgSrc:"static/image/micf_part8_bg4.png",
            txt:"安装简易喷淋",
            txt1:"独立式感烟火灾探测报警器",
            txtColor:"part8_itemInfo_txt1",
          },

        ],
        resultList:[
          {
            normalSrc:"static/image/mf_part5_bg1.png",
            txt1:"建站审批",
            txt2:["建站信息导入","消防审核","验收开通"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg2.png",
            txt1:"训练认证",
            txt2:["认证申请","认证审核","现场验收"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/micf_part5_bg3.png",
            txt1:"人才培训",
            txt2:["在线培训","现场培训","在线考试","消防站人才库"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg4.png",
            txt1:"应急联动处理",
            txt2:["联勤联训方案","联勤联训演练","应急联动处置"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg5.png",
            txt1:"一张图检测预警",
            txt2:["建站审核情况","训练认证情况","人才培养情况","应急联动情况","火灾风险预测预警"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
          {
            normalSrc:"static/image/mf_part5_bg6.png",
            txt1:"综合管理",
            txt2:["注册管理","建站标准管理","微型消防站MIP","培训考试题库管理","其他平台对接"],
            bgColor:"part5_item2_info",
            txt1Class:"part5_item2_txt1",
            txt2Class:"part5_item2_txt2",
          },
        ],
      }
    },
    methods:{
      addActive(e,index){
        this.partList[index].imgSrc = "static/image/micf_part2_bg"+(index+1)+"Active.png";
        this.partList[index].txtColor = "part2_itemInfo_txt1 part2_itemInfo_txt1Ac";
      },
      removeActive(e,index){
        this.partList[index].imgSrc = "static/image/micf_part2_bg"+(index+1)+".png";
        this.partList[index].txtColor = "part2_itemInfo_txt1";
      },
      addActive1(e,index){
        if(index == 2){
          this.resultList[index].normalSrc = "static/image/micf_part5_bg"+(index+1)+"Active.png";
        }else{
          this.resultList[index].normalSrc = "static/image/mf_part5_bg"+(index+1)+"Active.png";
        }
        this.resultList[index].bgColor = "part5_item2_info part5_item2_infoActive";
        this.resultList[index].txt1Class = "part5_item2_txt1 part5_item2_txt1Active";
        this.resultList[index].txt2Class = "part5_item2_txt2 part5_item2_txt2Active";
      },
      removeActive1(e,index){
        if(index == 2){
          this.resultList[index].normalSrc = "static/image/micf_part5_bg"+(index+1)+".png";
        }else{
          this.resultList[index].normalSrc = "static/image/mf_part5_bg"+(index+1)+".png";
        }
        this.resultList[index].bgColor = "part5_item2_info";
        this.resultList[index].txt1Class = "part5_item2_txt1";
        this.resultList[index].txt2Class = "part5_item2_txt2";
      },
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part1_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 0 0 0;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 60px 0;
  }
  .part1_section{
    width: 100%;
    /*height: 300px;*/
    box-sizing: border-box;
    display: flex;
  }
  .part1_section>div:nth-of-type(1){
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(2){
    display: inline-block;
    width:30px;
    height:3px;
    background:rgba(42,98,255,1);
    box-sizing: border-box;
    margin: 30px 0;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(3){
    width: 519px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
  }
  .part1_section>div:nth-of-type(2){
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: right;
  }
  .part1_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part1_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 0 30px 0;
  }
  .part2Box{
    width:100%;
    height:500px;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_item{
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .part2_itemInfo{
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    padding: 30px 0 0 0;
    align-items: center;
  }
  .part2_itemInfo_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    text-align: center;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .part2_itemInfo_txt1Ac{
    color: #2A62FF;
  }
  .part3Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part3_img{
    text-align: center;
  }
  .part5Box{
    width: 100%;
    height: 650px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    background:#ffffff;
  }
  .part5_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part5_content_btn{
    width:280px;
    height:60px;
    background:rgba(42,98,255,1);
    border-radius:5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part5_content_item{
    width: 1000px;
    height: 58px;
    border-bottom:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item>div{
    width: 50%;
    height: 100%;
    border-right:1px solid rgba(227,227,227,1);
    border-radius:1px;
  }
  .part5_content_item1{
    width: 1000px;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_content_item1>div{
    flex: 1;
  }
  .part5_content_item2{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part5_item2_info{
    width:180px;
    height:300px;
    background:rgba(240,240,240,1);
    border-radius:5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 20px 0 20px;
    cursor: pointer;
    text-align: center;
  }
  .part5_item2_infoActive{
    background: #2A62FF;
  }
  .part5_item2_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part5_item2_txt1Active{
    color: #FFFF00;
  }
  .part5_item2_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:30px;
  }
  .part5_item2_txt2Active{
    color: #FFFFFF;
  }
  .part5_content_border{
    border-right:1px solid rgba(227,227,227,1);
    border-left:1px solid rgba(227,227,227,1);
  }
  .part5_box2_txtInfo>div{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .part5_box2_txtInfo>div>span{
    font-size:12px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(195,206,234,1);
    line-height:22px;
  }
  .part6Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 30px 0;
  }
  .part6_content{
    width: 1200px;
  }
  .part6_content_txt{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(59,74,117,1);
    line-height:30px;
    padding: 30px 0;
  }
  .part6_content_img{
    text-align: center;
  }
  .part6_content_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part6_content_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 30px 160px 30px 220px;
    display: flex;
    justify-content: space-around;
  }
  .part6_content_txt2Space{
    padding: 30px 69px 30px 36px;
  }
  .part7Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    /*height:700px;*/
    background:rgba(238,242,254,1);
  }
  .part7_item{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    box-sizing: border-box;
  }
  .part7_item_box1{
    width:400px;
    background:rgba(238,242,254,1);
    box-sizing: border-box;
    padding:20px 20px 20px 30px;
  }
  .part7_item_txt{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part7_item_txt1{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part8Box{
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part8_itemInfo_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(42,98,255,1);
    line-height:30px;
    text-align: center;
    box-sizing: border-box;
  }
  .part9Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 60px 0;
  }
  .part9_content{
    width: 1200px;
    height:300px;
    display: flex;
  }
  .part9_item1{
    width:450px;
  }
  .part9_item2{
    flex: 1;
    background:rgba(238,242,254,1);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 30px;
  }
  .part9_item2_txt1{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part9_item2_txt2{
    display: inline-block;
    width:50px;
    height:2px;
    background:rgba(59,74,117,1);
    border-radius:1px;
    box-sizing: border-box;
    margin: 20px 0 20px 0;
  }
  .part9_item2_txt3{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part2Img{
    width: 42px;
  }
</style>



// WEBPACK FOOTER //
// src/components/info/microFire.vue